import React, { useState } from 'react';
import Button from '../../ui/Button';
import { registryLabel } from './mediaCreatorDomRegistry';

const SCOPES = [
  { id: 'selection', label: 'Selection' },
  { id: 'css', label: 'CSS only' },
  { id: 'whole', label: 'Whole design' },
];

const MediaCreatorAiRefine = ({
  selectedElementKey,
  registryEntries,
  onApply,
  busy,
}) => {
  const [instruction, setInstruction] = useState('');
  const [scope, setScope] = useState('selection');

  const handleApply = () => {
    const text = instruction.trim();
    if (text.length < 8) return;
    onApply?.({
      instruction: text,
      scope,
      target_key: scope === 'selection' ? selectedElementKey : undefined,
    });
  };

  return (
    <div className="mc-ai-refine">
      <label className="mc-field-label" htmlFor="mc-ai-refine-input">
        Describe a change
      </label>
      <textarea
        id="mc-ai-refine-input"
        className="mc-ai-refine-input"
        rows={4}
        placeholder="e.g. Make the gallery background a subtle gold-to-ink gradient"
        value={instruction}
        onChange={(e) => setInstruction(e.target.value)}
      />
      <div className="mc-ai-refine-scopes" role="group" aria-label="Refine scope">
        {SCOPES.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`mc-chip${scope === s.id ? ' on' : ''}`}
            onClick={() => setScope(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>
      {scope === 'selection' && selectedElementKey && (
        <p className="dd-muted mc-ai-refine-target">
          Target: {registryLabel(selectedElementKey, registryEntries || [])}
          <span className="mc-ai-refine-key"> ({selectedElementKey})</span>
        </p>
      )}
      {scope === 'selection' && !selectedElementKey && (
        <p className="dd-muted mc-ai-refine-hint">Select an element on the artboard for scoped edits.</p>
      )}
      <Button
        size="sm"
        loading={busy}
        disabled={instruction.trim().length < 8}
        onClick={handleApply}
      >
        Apply AI change
      </Button>
    </div>
  );
};

export default MediaCreatorAiRefine;
